const yardsToKph = (yardsPerSecond) => yardsPerSecond * 3.2928;
const yardsToMph = (yardsPerSecond) => yardsPerSecond * 2.04545;

export { yardsToKph, yardsToMph };
//# sourceMappingURL=distance.js.map
